export default __webpack_public_path__ + "static/media/AoPS.58ac85d6.png";